import type { ConversationAction } from '@atlassian/rovo-conversation-actions/types';
import { useRandomNumber } from './useRandomNumber.tsx';

export const useRandomNudge = (nudges: ConversationAction[]): ConversationAction | undefined => {
	const randomIndex = useRandomNumber(nudges.length - 1);

	if (nudges.length === 0) {
		return undefined;
	}

	if (randomIndex > nudges.length - 1) {
		return nudges[0];
	}

	return nudges[randomIndex];
};
